import React, { useEffect, useState } from 'react';
import { protectedFileUrl } from '../../lib/pb';

// Thumbnail strip for a job's protected photos. Filenames live in state;
// URLs are minted at mount with a fresh ~2min file token (see pb.js —
// tokens expire far too fast to bake URLs into long-lived state).
export default function JobPhotoStrip({ job, limit = 4, onOpen }) {
  const [urls, setUrls] = useState([]);
  const filenames = job?.photos || [];
  const shown = filenames.slice(0, limit);

  useEffect(() => {
    let active = true;
    if (!shown.length) {
      setUrls([]);
      return undefined;
    }
    (async () => {
      try {
        const minted = await Promise.all(
          shown.map((filename) => protectedFileUrl(
            { id: job.id, collectionName: 'jobs' },
            filename,
            { thumb: '200x200' },
          )),
        );
        if (active) setUrls(minted.filter(Boolean));
      } catch {
        if (active) setUrls([]);
      }
    })();
    return () => { active = false; };
  }, [job?.id, filenames.join(',')]);

  if (!urls.length) return null;

  return (
    <div className="job-thumbs">
      {urls.map((url, index) => (
        <img
          key={url}
          src={url}
          alt=""
          loading="lazy"
          onClick={onOpen ? () => onOpen(urls[index]) : undefined}
        />
      ))}
      {filenames.length > limit && <span>+{filenames.length - limit}</span>}
    </div>
  );
}
